import React from 'react';
import {observer} from 'mobx-react';
import {Modal} from 'shared/components/modals';
import {Note} from 'shared/components';
import {t} from 'shared/core';
import _ from 'lodash';

const ActionNoteModal = observer(({uiState, modalOpen}) => {
  const {selectedNote} = uiState;

  const {author, message} = selectedNote;

  return (
    <Modal
      size='md'
      isOpen={modalOpen}
      onHide={() => uiState.closeActionNoteModal()}
    >
      <Note
        title={t('employees.profile.time_off.NOTE_BY', {name: _.get(author, 'name')})}
        author={author}
      >
        {message}
      </Note>
    </Modal>
  );
});

export default ActionNoteModal;
